"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    StatusFeedback: ()=>StatusFeedback
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Image_index_cjs_namespaceObject = require("../Image/index.cjs");
const external_Heading_index_cjs_namespaceObject = require("../Heading/index.cjs");
const external_StatusFeedback_variants_cjs_namespaceObject = require("./StatusFeedback.variants.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
function StatusFeedback({ body, errorCode, heading, iconName = 'calendar_month', image, metaData, primaryAction, secondaryAction, statusFeedbackNode, ...props }) {
    const { root, iconImageWrapperSlot, buttonSlot, headingSlot, iconSlot, errorCodeSlot } = (0, external_StatusFeedback_variants_cjs_namespaceObject.statusFeedbackVariants)({
        ...props
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "@container",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: root(),
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: iconImageWrapperSlot(),
                    children: props.showIcon ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                        className: iconSlot(),
                        iconName: iconName,
                        size: "36"
                    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
                        children: image && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                            src: image.src,
                            alt: image.alt,
                            width: 80
                        })
                    })
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: "flex flex-col items-center gap-1 text-center",
                    children: [
                        errorCode && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Heading_index_cjs_namespaceObject.Heading, {
                            textStyle: "body2",
                            className: errorCodeSlot(),
                            children: errorCode
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Heading_index_cjs_namespaceObject.Heading, {
                            as: "h5",
                            className: headingSlot(),
                            children: heading
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.P, {
                            textStyle: "body2",
                            children: body
                        })
                    ]
                }),
                metaData && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.P, {
                    textStyle: "body3",
                    children: metaData
                }),
                statusFeedbackNode && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    children: statusFeedbackNode
                }),
                (secondaryAction || primaryAction) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: buttonSlot(),
                    children: [
                        secondaryAction,
                        primaryAction
                    ]
                })
            ]
        })
    });
}
exports.StatusFeedback = __webpack_exports__.StatusFeedback;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "StatusFeedback"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
